export default "__VITE_ASSET__B5KGso1y__"